




















import Vue from 'vue';
import Component from 'vue-class-component';
import HomeHowItWorksTab from './HomeHowItWorksTab.vue';
import {
  HowItWorksStep,
  iAcceptChallengesSteps,
  iHaveAChallengeSteps
} from '@/models/how-it-works.model';

@Component({
  components: {
    HomeHowItWorksTab
  }
})
export default class HomeHowItWorksTabs extends Vue {
  steps: Array<Array<HowItWorksStep>> = [];

  created() {
    this.steps.push(iAcceptChallengesSteps);
    this.steps.push(iHaveAChallengeSteps);
  }
}
